export var fileTypes = {
  jpg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png'
};
export var getInputFileAcceptByType = function getInputFileAcceptByType() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return types.map(type => fileTypes[type]).join(', ');
};
//# sourceMappingURL=get-input-file-accept.js.map